import keys from 'lodash/keys';
import get from 'lodash/get';

const _flattenKeys = (obj: any, keyPrefix: string): object => {
  const type = typeof obj;
  switch (type) {
    case 'object': {
      return keys(obj).reduce((accumulated, nextKey) => {
        Object.assign(accumulated, _flattenKeys(get(obj, nextKey), `${keyPrefix}.${nextKey}`));
        return accumulated;
      }, {});
    }
    case 'undefined':
    case 'boolean':
    case 'number':
    case 'string':
    case 'symbol':
    case 'bigint':
    case 'function':
      return {
        [keyPrefix]: obj,
      };
  }
};

const flattenKeys = (obj: object) => {
  return keys(obj).reduce((accumulated, nextKey) => {
    Object.assign(accumulated, _flattenKeys(get(obj, nextKey), `${nextKey}`));
    return accumulated;
  }, {});
};

export default flattenKeys;
